var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOsOtherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 14.4038L19.834 11.1628L25.6673 7.90547L19.834 4.66797L14.0007 7.90547L8.16732 4.66797L2.33398 7.90547L8.16732 11.1628L14.0007 14.4038Z",
    fill: "#6CEB08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.834 13.6016L14.0007 16.8402L8.16732 13.6016L2.33398 16.8402L8.16732 20.0976L14.0007 23.3351L19.834 20.0976L25.6673 16.8402L19.834 13.6016Z",
    fill: "#6CEB08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsOtherIcon);
export default __webpack_public_path__ + "static/media/OsOtherIcon.6130441b300749b929f7be9e2cffb031.svg";
export { ForwardRef as ReactComponent };